import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "examples/Sidenav";

import theme from "assets/theme";
import themeDark from "assets/theme-dark";

import "./assets/login.css";
import "./assets/sidenav.css";
import "./assets/validation.css";

import {
  useMaterialUIController,
  setMiniSidenav,
} from "context";

import { fetchAndFilterRoutes } from "routes";
import { fetchAndFilterRoutesAdmin } from "routes_admin";
import { fetchAndFilterRoutesMM } from "routes_admin";
import { fetchAndFilterRoutesTC } from "routes_admin";
import { fetchAndFilterRoutesServices } from "routes_services";
import routesSuperAdmin from "routers_superadmin";
import AppRoutes from "routes/app-routes";


export default function App() {

  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    sidenavColor,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  // const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  const [routes, setRoutes] = useState([]);
  
  const role = localStorage.getItem("role");
  const email = localStorage.getItem("email");
 
 useEffect(() => {
  const loadRoutes = async () => {
    let filteredRoutes = [];

    if (role === "Vendor") {
      filteredRoutes = await fetchAndFilterRoutes(email);
    } else if (role === "Admin") {
      filteredRoutes = await fetchAndFilterRoutesAdmin(email);
    } else if (role === "Services") {
      filteredRoutes = await fetchAndFilterRoutesServices(email);
    } else if (role === "Marketing Manager") {
      filteredRoutes = await fetchAndFilterRoutesMM(email);
    } else if (role === "Telecaller") {
      filteredRoutes = await fetchAndFilterRoutesTC(email);
    }

    setRoutes(filteredRoutes);
  };

  if (email && role) {
    loadRoutes();
  }
}, [email, role]);

  // useMemo(() => {
  //   const cacheRtl = createCache({
  //     key: "rtl",
  //     stylisPlugins: [rtlPlugin],
  //   });

  //   setRtlCache(cacheRtl);
  // }, []);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // const handleConfiguratorOpen = () =>
  //   setOpenConfigurator(dispatch, !openConfigurator);

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // const configsButton = (
  //   <MDBox
  //     display="flex"
  //     justifyContent="center"
  //     alignItems="center"
  //     width="3.25rem"
  //     height="3.25rem"
  //     bgColor="white"
  //     shadow="sm"
  //     borderRadius="50%"
  //     position="fixed"
  //     right="2rem"
  //     bottom="2rem"
  //     zIndex={99}
  //     color="dark"
  //     sx={{ cursor: "pointer" }}
  //     onClick={handleConfiguratorOpen}
  //   >
  //     <Icon fontSize="small" color="inherit">
  //       settings
  //     </Icon>
  //   </MDBox>
  // );

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
  color={sidenavColor}
  brandName={<div className="sidenav-brand-name">{role || "Vendor"}</div>}
  routes={role === "Super Admin" ? routesSuperAdmin : routes}
  onMouseEnter={handleOnMouseEnter}
  onMouseLeave={handleOnMouseLeave}
/>


          {/* <Configurator /> */}
          
          {/* {configsButton} */}
        </>
      )}

      <AppRoutes />
      
    </ThemeProvider>
  );
}